import { c as _c } from "react/compiler-runtime";
const AccordionTitle = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="headline-6">Scheda tecnica</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { AccordionTitle };